<template>
  <div class="d-flex flex-column py-5">
    <!-- <div class="d-block text-h6 black--text font-weight-bold mt-4">Lokasi Tokomu</div> -->
    
    <v-card flat outlined :loading="loading" class="mt-3">
      <v-card-text v-if="!loading">
        <v-form ref="formUpdatePass" role="form">
          <v-card class="mb-5">
            <v-card-title class="primary--text">Password Login Toko</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 text-left font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Password Baru</div></v-col>
                <v-col cols="12" sm="12" md="8"><v-text-field @click:append="showPassword" :type="passwordType" :rules="passwordRules" @focus="() => fieldErrors.password=''" :error-messages="fieldErrors.password" v-model="password" validate-on-blur single-line outlined class="color-primary rounded-lg password-field" height="40" dense :append-icon="passwordIcon" hide-details="auto"></v-text-field></v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" sm="12" md="4"><div class="text-body-2 font-weight-bold pb-1" style="width: 100%; margin-bottom: -10px;">Konfirmasi Password</div></v-col>
                <v-col cols="12" sm="12" md="8"><v-text-field @click:append="showPassword" :type="passwordType" :rules="repasswordRules" @focus="() => fieldErrors.repassword=''" :error-messages="fieldErrors.repassword" v-model="repassword" validate-on-blur single-line outlined class="color-primary rounded-lg password-field" height="40" dense :append-icon="passwordIcon" hide-details="auto"></v-text-field></v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <hr class="mt-5">
          <v-row>
            <v-col cols="12" sm="12" class="text-right">
              <v-btn
                color="green"
                :loading="loadingProcess"
                class="my-2 px-5 mx-1 text-capitalize white--text btn-block-xs font-weight-bold"
                :disabled="(password !== '' && repassword !== '') ? false : true"
                @click="processUpdate()"
              >
                Update Password
              </v-btn>
              <v-btn depressed large class="text-capitalize font-weight-bold text-body-2 btn-block-xs rounded-lg mx-1" @click="resetForm">Batalkan Update</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-text v-else>
        <div class="pa-4 rounded-lg" style="border: 1px solid #999;">Sedang menampilkan form update password Anda...</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'update-password-seller',
  data() {
    return {
      loadingProcess: false,
      loading: false,
      password: '',
      repassword: '',
      passwordType: 'password',
      passwordIcon: 'mdi-eye',
      passwordRules: [
        v => !!v || 'Password tidak boleh kosong',
        v => v.length > 5 || 'Password minimal 6 karakter',
        v => v.length <= 20 || 'Password maksimal 20 karakter',
      ],
      repasswordRules: [
        v => !!v || 'Konfirmasi Password tidak boleh kosong',
        v => v === this.password || 'Konfirmasi Password tidak cocok',
      ],
    }
  },

  computed: {
    ...mapState('auth', ['isAttempting', 'alerts', 'fieldErrors']),
  },

  methods: {
    ...mapActions('storeSeller', ['updateStorePassword']),
    ...mapMutations(['makeAlert']),

    showPassword() {
      if (this.passwordType == 'password') {
        this.passwordType = 'text'
        this.passwordIcon = 'mdi-eye-off'
      } else {
        this.passwordType = 'password'
        this.passwordIcon = 'mdi-eye'
      }
    },

    async processUpdate() {
			if(this.$refs.formUpdatePass.validate()) {
        this.loadingProcess = await true

        const apiParams = {
          store_password: this.password
        }
        
        this.updateStorePassword(apiParams)
          .then(() => {
            this.makeAlert({ code: 'success', type: 'success', message: this.response.message, show: true })
            
            this.loading = false
            this.loadingProcess = false
          })
          .catch(() => {
            this.loadingProcess = false
          })
          .finally(() => {
            this.resetForm()
            location.replace(location.href)
          })
			} else {
        this.loadingProcess = false
      }
    },

    resetForm() {
      this.loading = false
      this.password = ''
      this.repassword = ''
      this.passwordType = 'password'
      this.passwordIcon = 'mdi-eye'
    },
    
  },

  mounted() {
    // this.initData()
    this.loading = true

    setTimeout(() => {
      this.loading = false
    }, 1000);
  },

  created() {
    this.$store.dispatch('setPageTitle', `Update Password Login`);
  }
}
</script>